import type { StarterPrompt } from "../components/chat/WelcomeMessage";

/**
 * Default starter prompts shown when the DB has no prompts seeded
 * (e.g., local development). Keep in sync with deployed DynamoDB data.
 */
export const DEFAULT_STARTER_PROMPTS: StarterPrompt[] = [
  { icon: "✦", text: "Browse tires by size" },
  { icon: "✦", text: "Explore tire categories" },
  { icon: "✦", text: "Explore tire test results" },
  { icon: "✦", text: "Get help choosing tires for my car" },
];
